"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1854],{

/***/ 61854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Plp_MobileFilterFacets; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./hooks/useWindowSize.ts

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var ref = (0,react.useState)({
        width: 0,
        height: 0
    }), windowSize = ref[0], setWindowSize = ref[1];
    var handleResize = (0,react.useCallback)(function() {
        // Set window width/height to state
        if (false) {}
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }, []);
    (0,react.useEffect)(function() {
        // only execute all the code below in client side
        if (true) {
            // Handler to call on window resize
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }
        return function() {};
    }, [
        handleResize
    ]) // Empty array ensures that effect is only run on mount
    ;
    return windowSize;
}
/* harmony default export */ var hooks_useWindowSize = ((/* unused pure expression or super */ null && (useWindowSize)));

// EXTERNAL MODULE: ./node_modules/@csc/dls/Text.js
var Text = __webpack_require__(45468);
// EXTERNAL MODULE: ./node_modules/@csc/dls/IconRenderer.js
var IconRenderer = __webpack_require__(99821);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Icons/Filter.js
var Filter = __webpack_require__(40047);
// EXTERNAL MODULE: ./components/Plp/SortOptions.ts
var SortOptions = __webpack_require__(84522);
;// CONCATENATED MODULE: ./components/Plp/MobileFilterFacets.tsx









var MobileFilterFacets_Filter = dynamic_default()(__webpack_require__.e(/* import() */ 253).then(__webpack_require__.bind(__webpack_require__, 30253)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30253)
            ];
        }
    }
});
var Modal = dynamic_default()(__webpack_require__.e(/* import() */ 8558).then(__webpack_require__.bind(__webpack_require__, 28558)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28558)
            ];
        }
    }
});
var AjaxSpinner = dynamic_default()(__webpack_require__.e(/* import() */ 1458).then(__webpack_require__.bind(__webpack_require__, 11458)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11458)
            ];
        }
    }
});
var MobileFilterFacets = function(param) {
    var facets = param.facets, open = param.open, onClose = param.onClose, sortValue = param.sortValue, isLoading = param.isLoading, _displayCount = param.displayCount, displayCount = _displayCount === void 0 ? true : _displayCount, onFilterSelected = param.onFilterSelected, onSortChange = param.onSortChange, onClearFilters = param.onClearFilters;
    var width = useWindowSize().width;
    var isMobile = (0,react.useMemo)(function() {
        return width < 768;
    }, [
        width
    ]);
    var facetsWithoutReadyToShip = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(facets).filter(function(f) {
            return f.machineName !== "readyToShip";
        });
    }, [
        facets
    ]);
    return open && isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "vertical-filter block md:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
            open: open,
            onClose: onClose,
            type: "full",
            closeable: true,
            footerButtons: true,
            confirmButtonLabel: "Apply",
            cancelButtonLabel: "Clear",
            confirmButtonProps: {
                type: "primary",
                label: "Apply",
                id: "Apply",
                onClick: onClose
            },
            cancelButtonProps: {
                type: "secondary",
                label: "Clear",
                id: "Clear",
                onClick: function() {
                    onClearFilters();
                    onClose();
                }
            },
            children: open && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        onClick: onClose,
                        className: "cursor-pointer flex items-center w-fit sticky top-0 z-10 bg-white py-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRenderer["default"], {
                                IconComponent: Filter/* default */.ZP,
                                className: "mr-2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                children: "Close Filter"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterFacets_Filter, {
                        name: "filter",
                        filterLabel: "Filter By",
                        label: "Filter By",
                        onFilterChange: onFilterSelected,
                        sortLabel: "Sort by",
                        sortOptions: SortOptions/* SortOptions */.o,
                        onSortChange: onSortChange,
                        "data-testid": "mobile-facet",
                        id: "mobile-facet",
                        facets: facetsWithoutReadyToShip,
                        sortValue: sortValue,
                        displayCount: displayCount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AjaxSpinner, {
                        visible: isLoading
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var Plp_MobileFilterFacets = (MobileFilterFacets);


/***/ }),

/***/ 99821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var genSize = function genSize(size) {
    switch(size){
        case "2xl":
            return "w-32 h-32";
        //512x512
        case "xl":
            return "w-16 h-16";
        //64x64
        case "lg":
            return "w-8 h-8";
        //32x32
        case "md":
            return "w-5 h-5";
        //20x20
        case "sm":
            return "w-4 h-4";
        //16x16
        case "xxs":
            return "w-2 h-2";
        //8x8
        case "xs":
        default:
            //Default must be the last
            return "w-3 h-3";
    }
};
var IconRenderer = function IconRenderer(_a) {
    var IconComponent = _a.IconComponent, _b = _a.size, size = _b === void 0 ? "md" : _b, color = _a.color, loadingStyle = _a.loadingStyle, className = _a.className, rest = __rest(_a, [
        "IconComponent",
        "size",
        "color",
        "loadingStyle",
        "className"
    ]);
    var sizeClass = size && genSize(size);
    var colorStyle = color ? {
        fill: color
    } : {};
    var loadingClass = loadingStyle && "animate-".concat(loadingStyle);
    return /*#__PURE__*/ React__default["default"].createElement(IconComponent, _extends({
        style: colorStyle,
        className: "".concat(color ? color : "fill-current", " ").concat(sizeClass ? sizeClass : "", " ").concat(loadingClass ? loadingClass : "", " ").concat(className ? className : "")
    }, rest));
};
exports.IconRenderer = IconRenderer;
exports["default"] = IconRenderer; //# sourceMappingURL=IconRenderer.js.map


/***/ }),

/***/ 40047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgFilter = function SvgFilter(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "22",
        height: "14",
        viewBox: "0 0 22 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ React__namespace.createElement("rect", {
        y: "2",
        width: "22",
        height: "1",
        fill: "black"
    }), /*#__PURE__*/ React__namespace.createElement("rect", {
        y: "11",
        width: "22",
        height: "1",
        fill: "black"
    }), /*#__PURE__*/ React__namespace.createElement("circle", {
        cx: "7.5",
        cy: "2.5",
        r: "2.5",
        fill: "black"
    }), /*#__PURE__*/ React__namespace.createElement("circle", {
        cx: "14.5",
        cy: "11.5",
        r: "2.5",
        fill: "black"
    }));
};
__webpack_unused_export__ = SvgFilter;
exports.ZP = SvgFilter; //# sourceMappingURL=Filter.js.map


/***/ }),

/***/ 45468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var ThemeContext = /*#__PURE__*/ React.createContext({
    themeId: "",
    typographyComponents: {},
    brandVariables: {}
});
var useTheme = function useTheme() {
    return React.useContext(ThemeContext);
};
var TagRenderer = function TagRenderer(_a) {
    var children = _a.children, textTag = _a.textTag, rest = __rest(_a, [
        "children",
        "textTag"
    ]);
    if (typeof textTag === "string") {
        switch(textTag){
            case "h1":
                return /*#__PURE__*/ React__default["default"].createElement("h1", rest, children);
            case "h2":
                return /*#__PURE__*/ React__default["default"].createElement("h2", rest, children);
            case "h3":
                return /*#__PURE__*/ React__default["default"].createElement("h3", rest, children);
            case "h4":
                return /*#__PURE__*/ React__default["default"].createElement("h4", rest, children);
            case "h5":
                return /*#__PURE__*/ React__default["default"].createElement("h5", rest, children);
            case "h6":
                return /*#__PURE__*/ React__default["default"].createElement("h6", rest, children);
            case "span":
                return /*#__PURE__*/ React__default["default"].createElement("span", rest, children);
            case "p":
            default:
                return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
        }
    }
    return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
};
var LegacyText = function LegacyText(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.bold, bold = _d === void 0 ? false : _d, _e = _a.link, link = _e === void 0 ? false : _e;
    _a.id;
    var children = _a.children, _g = _a.textTag, textTag = _g === void 0 ? "p" : _g, rest = __rest(_a, [
        "className",
        "size",
        "bold",
        "link",
        "id",
        "children",
        "textTag"
    ]);
    var classes = "".concat(!!className ? className : "", " text-body-").concat(size, "-").concat(!!link ? "link" : !!bold ? "bold" : "normal");
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        className: classes,
        textTag: textTag
    }, rest), children);
};
var Text = function Text(_a) {
    var _b;
    var textId = _a.textId, className = _a.className, children = _a.children, _c = _a.textTag, textTag = _c === void 0 ? "p" : _c, rest = __rest(_a, [
        "textId",
        "className",
        "children",
        "textTag"
    ]);
    var typographyComponents = useTheme().typographyComponents;
    if (!textId || !typographyComponents) {
        return /*#__PURE__*/ React__default["default"].createElement(LegacyText, _extends({
            className: className,
            textTag: textTag
        }, rest), children);
    }
    var props = __assign({
        className: "".concat(className || "", " ").concat(textId)
    }, rest);
    var inputTag = textTag || ((_b = typographyComponents === null || typographyComponents === void 0 ? void 0 : typographyComponents[textId]) === null || _b === void 0 ? void 0 : _b.htmlComponent);
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        textTag: inputTag
    }, props), children);
};
__webpack_unused_export__ = LegacyText;
__webpack_unused_export__ = Text;
exports.ZP = Text; //# sourceMappingURL=Text.js.map


/***/ })

}]);